import { WithID } from '@psl/functions/firebase/rxfireExtensions';
import { PrivateProfile } from '@psl/models/ClientModels';

export const useIsCommentChatValid = (
  privateProfile: WithID<PrivateProfile>,
) => {
  return Boolean(privateProfile.commentchat?.onboardingFinished);
};
